// Constant Data that related to User domain

export const GENDER = {
  FEMALE : 'female',
  MALE   : 'male'
}

export const CUSTOMER_TYPE = {
  normal   : 'normal',
  reseller : 'reseller'
}

export const VERIFICATION_METHOD = {
  email        : 'email',
  sms          : 'sms',
  whatsapp     : 'whatsapp',
  not_verified : 'not_verified'
}
